
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'customer-portal-app',
  currentProjectVersion: 'static-1.2400',
  depVersions: {
  "customer-portal-app": "static-1.2400",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.469",
  "data-fetching-client": "static-1.9698",
  "emoji-mart": "static-3.4",
  "enviro": "static-4.455",
  "growth-payments-core": "static-1.25462",
  "head-dlb": "static-1.5007",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5622",
  "hs-test-utils": "static-1.8045",
  "hub-http": "static-1.6253",
  "hub-http-shared-msw-handlers": "static-1.10034",
  "hubspot-dlb": "static-2.1854",
  "hubspot-prosemirror": "static-1.18313",
  "hubspot-url-utils": "static-1.4132",
  "HubStyleTokens": "static-2.11503",
  "I18n": "static-7.1631",
  "immutable": "static-2.79",
  "jasmine-runner": "static-1.6495",
  "payment-link-components": "static-1.23622",
  "prosemirror": "static-1.13",
  "quartz": "static-1.7069",
  "quartz-core": "static-1.6288",
  "quartz-i18n": "static-1.744",
  "react": "static-7.186",
  "react-colorpicker": "static-2.10239",
  "react-dlb": "static-1.79",
  "react-utils": "static-2.5369",
  "rich-text-lib": "static-1.19883",
  "transmute": "static-2.85",
  "ui-addon-upgrades": "static-9.18041",
  "ui-components-test-utils": "static-1.5640",
  "UIComponents": "static-3.8449",
  "foundations-assets": "static-1.4899",
  "foundations-components": "static-1.7994",
  "foundations-theming": "static-1.4451",
  "foundations-theming-specialty": "static-1.2167",
  "framer-motion": "static-1.72",
  "metrics-js": "static-1.9637",
  "PortalIdParser": "static-2.404",
  "portals-platform-lib": "static-1.942",
  "quartz-config": "static-1.847",
  "quartz-routing": "static-1.499",
  "quick-fetch": "static-1.3941",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1.16705",
  "rpc-client-utils": "static-1.4684",
  "sanitize-text": "static-1.8174",
  "styled-components": "static-2.89",
  "tanstack-table": "static-1.55",
  "ui-addon-draggable": "static-3.4794",
  "ui-addon-react-router-dom": "static-1.9573",
  "usage-tracker": "static-1.7379",
  "usage-tracker-anonymous": "static-1.5796",
  "usage-tracker-core": "static-1.7229",
  "video-components-external": "static-1.11384",
  "apollo-stack-hubspot": "static-3.84",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "bend-plugin-trellis-migration": "static-1.3423",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3346",
  "quartz-webpack": "static-1.3293",
  "bend-plugin-quartz-routing": "static-1.147",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.82",
  "customer-data-objects": "static-1.7705",
  "frontend-preferences-client": "static-1.7958",
  "laboratory-lib": "static-3.7187",
  "onboarding-scopes": "static-1.6492",
  "seat-types-lib": "static-1.80",
  "ui-addon-opt": "static-4.8395",
  "HeadJS": "static-2.764",
  "hs-test-utils-bend-plugin": "static-1.3156",
  "msw": "static-1.39",
  "testing-library": "static-1.152",
  "hs-locale-management": "static-1.105",
  "ts-schema": "static-1.4105",
  "webpack-env": "static-1.54",
  "content-assistance-lib": "static-1.7797",
  "cssUtils": "static-1.798",
  "customer-data-ui-utilities": "static-1.9857",
  "HubStyle": "static-2.11810",
  "knowledge-content-types": "static-1.8503",
  "PatternValidationJS": "static-1.437",
  "react-input-autosize": "static-2.17",
  "StyleGuideUI": "static-3.487",
  "ui-addon-emoji-picker": "static-1.9919",
  "ui-addon-i18n": "static-1.11180",
  "ui-business-units-lib": "static-1.9087",
  "ui-shepherd-react": "static-3.10202",
  "i18n-data": "static-1.221",
  "moment-timezone": "static-5.83",
  "jasmine": "static-4.4358",
  "commerce-tours-lib": "static-1.6157",
  "customer-data-properties": "static-1.51670",
  "getting-started-shared-tasks": "static-1.18529",
  "growth-onboarding-reliability": "static-1.5113",
  "onboarding-tours": "static-1.16670",
  "reference-resolvers-lite": "static-1.8126",
  "sales-checkout-service-client": "static-1.3673",
  "ui-addon-iframeable": "static-1.9092",
  "user-context": "static-1.5136",
  "dispatcher": "static-1.137",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.838",
  "hubspotter-http": "static-1.4676",
  "icons": "static-2.650",
  "mobile-manifest-mixins": "static-1.538",
  "module-federation": "static-1.23",
  "quartz-auth": "static-1.744",
  "quartz-head": "static-1.734",
  "quartz-test": "static-1.744",
  "quartz-tracking": "static-1.448",
  "ui-fonts": "static-1.765",
  "usage-tracker-container": "static-1.7369",
  "csstype": "static-1.50",
  "hs-story-utils": "static-1.9455",
  "data-token-picker": "static-1.16457",
  "FileManagerLib": "static-1.39343",
  "property-translator": "static-1.5430",
  "atom": "static-1.5104",
  "merchandise-lib": "static-1.264",
  "purchase-motions-components": "static-1.5974",
  "salesImages": "static-1.525",
  "SharedI18nStrings": "static-1.182",
  "foundations-components-test-utils": "static-1.5477",
  "react-select-plus": "static-1.105",
  "react-virtualized": "static-2.99",
  "ui-images": "static-2.1160",
  "bend-plugin-foundations-components": "static-1.4263",
  "floating-ui": "static-1.56",
  "react-aria": "static-1.66",
  "react-create-root-preference": "static-1.29",
  "trellis-assets": "static-1.2036",
  "bend-plugin-foundations-theming": "static-1.2934",
  "foundations-theming-base": "static-1.3436",
  "stylex": "static-1.33",
  "interframe": "static-3.4791",
  "js-cookie": "static-1.18",
  "usage-tracker-multi": "static-1.5793",
  "web-vitals": "static-1.6",
  "bend-plugin-chirp-manifest": "static-1.94",
  "chirp-fetch": "static-1.1919",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4507",
  "react-flip-move": "static-1.70",
  "apollo-link-hub-http": "static-2.4683",
  "content-media-composition-data-lib": "static-1.12428",
  "content-media-compositions": "static-2.16435",
  "idb-keyval": "static-1.44",
  "immer": "static-1.33",
  "immerable": "static-1.4185",
  "magpie-lib": "static-1.5571",
  "magpie-types": "static-1.5031",
  "media-bridge-lib": "static-1.18976",
  "video-data-lib": "static-1.35042",
  "bender-build-tools": "static-1.3227",
  "inbound-db-properties-service-client": "static-1.3871",
  "superstore": "static-1.4792",
  "feedback-loader": "static-1.29350",
  "ai-components-ui-library": "static-1.9045",
  "ui-addon-video-player": "static-1.8734",
  "ui-coaching-tips": "static-1.28642",
  "sassPrefix": "static-1.156",
  "react-dnd-compat": "static-1.4646",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "avatar-components": "static-1.2529",
  "navigation-messaging": "static-1.7442",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.8202",
  "reselect": "static-2.16",
  "commerce-products-lib": "static-1.9675",
  "crm-message-bus": "static-1.43044",
  "growth-data-modal": "static-1.5474",
  "hubspot-apollo-client": "static-1.4910",
  "onboarding-tours-client": "static-1.4884",
  "calling-global-api": "static-1.64615",
  "calling-internal-common": "static-1.31333",
  "calling-lifecycle-internal": "static-1.65997",
  "calling-lifecycle-messages": "static-1.58291",
  "conditional-properties-service-client": "static-1.3822",
  "crm-links": "static-1.6326",
  "customer-data-objects-ui-components": "static-1.13060",
  "customer-data-properties-shared-msw-handlers": "static-1.9361",
  "customer-data-property-utils": "static-1.8122",
  "external-options-client-types": "static-1.4184",
  "file-manager-components": "static-1.23703",
  "framework-data-schema-resolvers": "static-1.6916",
  "google-libphonenumber": "static-1.38",
  "hs-resources": "static-1.188",
  "inbound-db-meta-service-client": "static-1.3611",
  "inbounddb-objects-service-types": "static-1.4248",
  "meetings-icalendar-utils-lib": "static-1.663",
  "multi-currency-client-types": "static-1.3716",
  "object-builder-ui-client": "static-1.48842",
  "pipeline-validation-client-types": "static-1.3990",
  "property-value-citations": "static-1.2284",
  "pulse": "static-1.611",
  "smart-property-lib": "static-1.7241",
  "tiered-pricing": "static-1.1282",
  "zustand": "static-1.74",
  "ui-addon-form-validation": "static-1.11021",
  "growth-onboarding-confetti": "static-1.3098",
  "growth-onboarding-next-action-utils": "static-1.2004",
  "navigation-components": "static-1.18115",
  "onboarding-tours-utils": "static-1.736",
  "ui-shepherd-tracker": "static-1.7583",
  "ui-universal-auth": "static-1.9014",
  "batch-promise": "static-1.1573",
  "getting-started-shared-tasks-store": "static-1.17647",
  "hubspotter-http-shared-msw-handlers": "static-1.10032",
  "usage-tracker-session-replay": "static-1.5065",
  "audio-components": "static-1.5960",
  "FileManagerCore": "static-1.39202",
  "FileManagerImages": "static-1.36854",
  "video-components": "static-1.13387",
  "foundations-components-legacy": "static-1.1019",
  "purchase-motions-api": "static-1.5977",
  "signup-constants": "static-1.18900",
  "signup-ui-url-generator": "static-2.8084",
  "usage-tracker-public": "static-1.7190",
  "reactive-lib": "static-1.754",
  "simple-logging-lib": "static-1.3082",
  "chatspot-core": "static-1.21415",
  "ContentUtils": "static-1.68452",
  "copilot-toolkit": "static-1.11208",
  "growth-onboarding-feedback-components": "static-1.6611",
  "commerce-permissions": "static-1.802",
  "customer-data-tracking": "static-1.6921",
  "products-iframe-lib": "static-1.8018",
  "products-ui-components-shared-msw-handlers": "static-1.10416",
  "restore-request-side-panel-lib": "static-1.978",
  "onboarding-data-sync-lib": "static-1.2003",
  "hubspot-apollo-cache": "static-1.369",
  "calling-error-reporting": "static-1.31340",
  "shared-worker-versioning": "static-1.11068",
  "calling-usage-tracker": "static-1.6572",
  "self-service-api": "static-1.10279",
  "voice-sms-access-library": "static-1.1102",
  "conversations-skeleton-state": "static-1.7279",
  "location-customization-utils-lib": "static-1.9349",
  "crm-pipelines-api-client-types": "static-1.4164",
  "fdsr-migration-layer": "static-1.35",
  "framework-builder-read-service-client": "static-1.4029",
  "framework-data-schema-quick-fetch": "static-1.6821",
  "persist-promise": "static-1.3730",
  "bend-plugin-pulse": "static-1.114",
  "event-emitter": "static-1.979",
  "fast-json-patch": "static-1.63",
  "data-agent-kit": "static-1.241",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10117",
  "fsm": "static-1.3763",
  "policy-lib": "static-1.6808",
  "react-tinymce": "static-1.55326",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10180",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54452",
  "tinymce-plugins": "static-1.57566",
  "tinymce-themes": "static-1.56422",
  "growth-onboarding-next-action-components": "static-1.2032",
  "user-context-client": "static-1.4643",
  "nest": "static-1.261",
  "unified-auth-core-lib": "static-1.810",
  "amplitude-session-replay-browser": "static-1.60",
  "cropperjs": "static-1.10",
  "redux-toolkit": "static-1.7",
  "urlinator": "static-1.4568",
  "video-embed": "static-1.35876",
  "content-icons-ui": "static-1.2233",
  "social-insights-client-types": "static-1.22193",
  "markdown-it": "static-1.6",
  "cms-field-types": "static-1.4843",
  "integrations-lib": "static-1.16252",
  "underscore": "static-1.8",
  "sales-views-client-types": "static-1.4290",
  "InboxConnectUtils": "static-4.14896",
  "meetings-connect-utils-lib": "static-1.7636",
  "calling-orchestration-schema": "static-1.35879",
  "crm-record-cards-service-types": "static-1.3615",
  "highcharts": "static-8.104",
  "trellis-story-utils": "static-1.4546",
  "storybook-react": "static-1.33",
  "hub-http-contrib": "static-1.3073",
  "tinymce-data": "static-1.40537",
  "ui-addon-sales-email": "static-1.5242",
  "codemirror": "static-5.95",
  "layout-dnd-components": "static-1.12500",
  "layout-dnd-utils": "static-1.11475",
  "react-codemirror": "static-1.10657",
  "ui-brand-identity-lib": "static-1.15409",
  "NamespacedHubStyle": "static-2.9083",
  "outpost": "static-1.4209",
  "flux-actions": "static-1.341",
  "integrations-error-boundary-lib": "static-1.13667",
  "integrations-tracking-lib": "static-1.5633",
  "native-integrations-shared-strings": "static-1.7813",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10397",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.528",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.68527",
  "layout-data-lib": "static-1.9800",
  "browser-eslint": "static-2.57",
  "universal-page-editor-lib": "static-1.3044",
  "google-sheets-integration-lib": "static-1.324",
  "microsoft-drive-integration-lib": "static-1.449",
  "slack-ui-library": "static-1.10423",
  "advanced-menus-core": "static-1.15174",
  "advanced-menus-lib": "static-1.12112",
  "ExportDialog": "static-6.10415",
  "ui-memberships-settings-lib": "static-1.34127",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15173",
  "simple-menus-lib": "static-1.16690"
},
  depPathPrefixes: {
  "customer-portal-app": "/customer-portal-app/static-1.2400",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.469",
  "data-fetching-client": "/data-fetching-client/static-1.9698",
  "emoji-mart": "/emoji-mart/static-3.4",
  "enviro": "/enviro/static-4.455",
  "growth-payments-core": "/growth-payments-core/static-1.25462",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5622",
  "hs-test-utils": "/hs-test-utils/static-1.8045",
  "hub-http": "/hub-http/static-1.6253",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10034",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18313",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyleTokens": "/HubStyleTokens/static-2.11503",
  "I18n": "/I18n/static-7.1631",
  "immutable": "/immutable/static-2.79",
  "jasmine-runner": "/jasmine-runner/static-1.6495",
  "payment-link-components": "/payment-link-components/static-1.23622",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.7069",
  "quartz-core": "/quartz-core/static-1.6288",
  "quartz-i18n": "/quartz-i18n/static-1.744",
  "react": "/react/static-7.186",
  "react-colorpicker": "/react-colorpicker/static-2.10239",
  "react-dlb": "/react-dlb/static-1.79",
  "react-utils": "/react-utils/static-2.5369",
  "rich-text-lib": "/rich-text-lib/static-1.19883",
  "transmute": "/transmute/static-2.85",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18041",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5640",
  "UIComponents": "/UIComponents/static-3.8449",
  "foundations-assets": "/foundations-assets/static-1.4899",
  "foundations-components": "/foundations-components/static-1.7994",
  "foundations-theming": "/foundations-theming/static-1.4451",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2167",
  "framer-motion": "/framer-motion/static-1.72",
  "metrics-js": "/metrics-js/static-1.9637",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "portals-platform-lib": "/portals-platform-lib/static-1.942",
  "quartz-config": "/quartz-config/static-1.847",
  "quartz-routing": "/quartz-routing/static-1.499",
  "quick-fetch": "/quick-fetch/static-1.3941",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1.16705",
  "rpc-client-utils": "/rpc-client-utils/static-1.4684",
  "sanitize-text": "/sanitize-text/static-1.8174",
  "styled-components": "/styled-components/static-2.89",
  "tanstack-table": "/tanstack-table/static-1.55",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4794",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9573",
  "usage-tracker": "/usage-tracker/static-1.7379",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5796",
  "usage-tracker-core": "/usage-tracker-core/static-1.7229",
  "video-components-external": "/video-components-external/static-1.11384",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3423",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3346",
  "quartz-webpack": "/quartz-webpack/static-1.3293",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.147",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.82",
  "customer-data-objects": "/customer-data-objects/static-1.7705",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7958",
  "laboratory-lib": "/laboratory-lib/static-3.7187",
  "onboarding-scopes": "/onboarding-scopes/static-1.6492",
  "seat-types-lib": "/seat-types-lib/static-1.80",
  "ui-addon-opt": "/ui-addon-opt/static-4.8395",
  "HeadJS": "/HeadJS/static-2.764",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3156",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.152",
  "hs-locale-management": "/hs-locale-management/static-1.105",
  "ts-schema": "/ts-schema/static-1.4105",
  "webpack-env": "/webpack-env/static-1.54",
  "content-assistance-lib": "/content-assistance-lib/static-1.7797",
  "cssUtils": "/cssUtils/static-1.798",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9857",
  "HubStyle": "/HubStyle/static-2.11810",
  "knowledge-content-types": "/knowledge-content-types/static-1.8503",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "StyleGuideUI": "/StyleGuideUI/static-3.487",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9919",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11180",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9087",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10202",
  "i18n-data": "/i18n-data/static-1.221",
  "moment-timezone": "/moment-timezone/static-5.83",
  "jasmine": "/jasmine/static-4.4358",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6157",
  "customer-data-properties": "/customer-data-properties/static-1.51670",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18529",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5113",
  "onboarding-tours": "/onboarding-tours/static-1.16670",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8126",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3673",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9092",
  "user-context": "/user-context/static-1.5136",
  "dispatcher": "/dispatcher/static-1.137",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.838",
  "hubspotter-http": "/hubspotter-http/static-1.4676",
  "icons": "/icons/static-2.650",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.538",
  "module-federation": "/module-federation/static-1.23",
  "quartz-auth": "/quartz-auth/static-1.744",
  "quartz-head": "/quartz-head/static-1.734",
  "quartz-test": "/quartz-test/static-1.744",
  "quartz-tracking": "/quartz-tracking/static-1.448",
  "ui-fonts": "/ui-fonts/static-1.765",
  "usage-tracker-container": "/usage-tracker-container/static-1.7369",
  "csstype": "/csstype/static-1.50",
  "hs-story-utils": "/hs-story-utils/static-1.9455",
  "data-token-picker": "/data-token-picker/static-1.16457",
  "FileManagerLib": "/FileManagerLib/static-1.39343",
  "property-translator": "/property-translator/static-1.5430",
  "atom": "/atom/static-1.5104",
  "merchandise-lib": "/merchandise-lib/static-1.264",
  "purchase-motions-components": "/purchase-motions-components/static-1.5974",
  "salesImages": "/salesImages/static-1.525",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5477",
  "react-select-plus": "/react-select-plus/static-1.105",
  "react-virtualized": "/react-virtualized/static-2.99",
  "ui-images": "/ui-images/static-2.1160",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4263",
  "floating-ui": "/floating-ui/static-1.56",
  "react-aria": "/react-aria/static-1.66",
  "react-create-root-preference": "/react-create-root-preference/static-1.29",
  "trellis-assets": "/trellis-assets/static-1.2036",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2934",
  "foundations-theming-base": "/foundations-theming-base/static-1.3436",
  "stylex": "/stylex/static-1.33",
  "interframe": "/interframe/static-3.4791",
  "js-cookie": "/js-cookie/static-1.18",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5793",
  "web-vitals": "/web-vitals/static-1.6",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.94",
  "chirp-fetch": "/chirp-fetch/static-1.1919",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4507",
  "react-flip-move": "/react-flip-move/static-1.70",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4683",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12428",
  "content-media-compositions": "/content-media-compositions/static-2.16435",
  "idb-keyval": "/idb-keyval/static-1.44",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4185",
  "magpie-lib": "/magpie-lib/static-1.5571",
  "magpie-types": "/magpie-types/static-1.5031",
  "media-bridge-lib": "/media-bridge-lib/static-1.18976",
  "video-data-lib": "/video-data-lib/static-1.35042",
  "bender-build-tools": "/bender-build-tools/static-1.3227",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3871",
  "superstore": "/superstore/static-1.4792",
  "feedback-loader": "/feedback-loader/static-1.29350",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9045",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8734",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28642",
  "sassPrefix": "/sassPrefix/static-1.156",
  "react-dnd-compat": "/react-dnd-compat/static-1.4646",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "avatar-components": "/avatar-components/static-1.2529",
  "navigation-messaging": "/navigation-messaging/static-1.7442",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.8202",
  "reselect": "/reselect/static-2.16",
  "commerce-products-lib": "/commerce-products-lib/static-1.9675",
  "crm-message-bus": "/crm-message-bus/static-1.43044",
  "growth-data-modal": "/growth-data-modal/static-1.5474",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4910",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4884",
  "calling-global-api": "/calling-global-api/static-1.64615",
  "calling-internal-common": "/calling-internal-common/static-1.31333",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65997",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58291",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3822",
  "crm-links": "/crm-links/static-1.6326",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13060",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9361",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8122",
  "external-options-client-types": "/external-options-client-types/static-1.4184",
  "file-manager-components": "/file-manager-components/static-1.23703",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6916",
  "google-libphonenumber": "/google-libphonenumber/static-1.38",
  "hs-resources": "/hs-resources/static-1.188",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3611",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4248",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.663",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3716",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48842",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3990",
  "property-value-citations": "/property-value-citations/static-1.2284",
  "pulse": "/pulse/static-1.611",
  "smart-property-lib": "/smart-property-lib/static-1.7241",
  "tiered-pricing": "/tiered-pricing/static-1.1282",
  "zustand": "/zustand/static-1.74",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11021",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3098",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2004",
  "navigation-components": "/navigation-components/static-1.18115",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.736",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7583",
  "ui-universal-auth": "/ui-universal-auth/static-1.9014",
  "batch-promise": "/batch-promise/static-1.1573",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17647",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10032",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5065",
  "audio-components": "/audio-components/static-1.5960",
  "FileManagerCore": "/FileManagerCore/static-1.39202",
  "FileManagerImages": "/FileManagerImages/static-1.36854",
  "video-components": "/video-components/static-1.13387",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1019",
  "purchase-motions-api": "/purchase-motions-api/static-1.5977",
  "signup-constants": "/signup-constants/static-1.18900",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8084",
  "usage-tracker-public": "/usage-tracker-public/static-1.7190",
  "reactive-lib": "/reactive-lib/static-1.754",
  "simple-logging-lib": "/simple-logging-lib/static-1.3082",
  "chatspot-core": "/chatspot-core/static-1.21415",
  "ContentUtils": "/ContentUtils/static-1.68452",
  "copilot-toolkit": "/copilot-toolkit/static-1.11208",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6611",
  "commerce-permissions": "/commerce-permissions/static-1.802",
  "customer-data-tracking": "/customer-data-tracking/static-1.6921",
  "products-iframe-lib": "/products-iframe-lib/static-1.8018",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10416",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.978",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2003",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.369",
  "calling-error-reporting": "/calling-error-reporting/static-1.31340",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11068",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6572",
  "self-service-api": "/self-service-api/static-1.10279",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1102",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7279",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9349",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4164",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.35",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4029",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6821",
  "persist-promise": "/persist-promise/static-1.3730",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.114",
  "event-emitter": "/event-emitter/static-1.979",
  "fast-json-patch": "/fast-json-patch/static-1.63",
  "data-agent-kit": "/data-agent-kit/static-1.241",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10117",
  "fsm": "/fsm/static-1.3763",
  "policy-lib": "/policy-lib/static-1.6808",
  "react-tinymce": "/react-tinymce/static-1.55326",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10180",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54452",
  "tinymce-plugins": "/tinymce-plugins/static-1.57566",
  "tinymce-themes": "/tinymce-themes/static-1.56422",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2032",
  "user-context-client": "/user-context-client/static-1.4643",
  "nest": "/nest/static-1.261",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.810",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "cropperjs": "/cropperjs/static-1.10",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "urlinator": "/urlinator/static-1.4568",
  "video-embed": "/video-embed/static-1.35876",
  "content-icons-ui": "/content-icons-ui/static-1.2233",
  "social-insights-client-types": "/social-insights-client-types/static-1.22193",
  "markdown-it": "/markdown-it/static-1.6",
  "cms-field-types": "/cms-field-types/static-1.4843",
  "integrations-lib": "/integrations-lib/static-1.16252",
  "underscore": "/underscore/static-1.8",
  "sales-views-client-types": "/sales-views-client-types/static-1.4290",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14896",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7636",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35879",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3615",
  "highcharts": "/highcharts/static-8.104",
  "trellis-story-utils": "/trellis-story-utils/static-1.4546",
  "storybook-react": "/storybook-react/static-1.33",
  "hub-http-contrib": "/hub-http-contrib/static-1.3073",
  "tinymce-data": "/tinymce-data/static-1.40537",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5242",
  "codemirror": "/codemirror/static-5.95",
  "layout-dnd-components": "/layout-dnd-components/static-1.12500",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11475",
  "react-codemirror": "/react-codemirror/static-1.10657",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15409",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9083",
  "outpost": "/outpost/static-1.4209",
  "flux-actions": "/flux-actions/static-1.341",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13667",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5633",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7813",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10397",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.528",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.68527",
  "layout-data-lib": "/layout-data-lib/static-1.9800",
  "browser-eslint": "/browser-eslint/static-2.57",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3044",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.324",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.449",
  "slack-ui-library": "/slack-ui-library/static-1.10423",
  "advanced-menus-core": "/advanced-menus-core/static-1.15174",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12112",
  "ExportDialog": "/ExportDialog/static-6.10415",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34127",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15173",
  "simple-menus-lib": "/simple-menus-lib/static-1.16690"
}
};
